"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StornoReasonEnum = void 0;
var StornoReasonEnum;
(function (StornoReasonEnum) {
    StornoReasonEnum["HighPrice"] = "highPrice";
    StornoReasonEnum["DoNotUsePremiumFeatures"] = "doNotUsePremiumFeatures";
    StornoReasonEnum["UsingAlternativeService"] = "usingAlternativeService";
    StornoReasonEnum["DoNotInvest"] = "doNotInvest";
    StornoReasonEnum["Other"] = "other";
    StornoReasonEnum["UnusedPremiumFeatures"] = "unusedPremiumFeatures";
    StornoReasonEnum["Competition"] = "competition";
    StornoReasonEnum["DoneWithInvesting"] = "doneWithInvesting";
})(StornoReasonEnum = exports.StornoReasonEnum || (exports.StornoReasonEnum = {}));
//# sourceMappingURL=storno-reason-enum.js.map